import colors from '_containers/Theme/intheblack/colors';

export default {
  action: colors.all.brandPrimary1,
  attributeIcon: colors.all.neutral700,
  cardBackground: colors.all.neutralWhite,
};
